import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import cx from 'classnames/bind';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import BaseLayout from '../../../../components/Layout/Brand/BaseLayout';
import CampaignManagerComponent from '../../../../components/Brand/Campaign/Manager';
import { brandCampaignManager, brandCampaignManagerSave, genericAction } from '../../../../actions';
import CurrentCampaignSidebar from '../../../../components/Brand/Sidebar/CurrentCampaign';
import notification from '../../../../components/UIElems/Notification';

const CampaignManager = (props) => {
    const [campaignDetails, setCampaignDetails] = useState(null);

    //campaign basic details
    useEffect(() => {
        props.actions.genericAction('campaignDetailSpecificFields', [['tapfluencer_campaign.campaign_name as campaignName'], props.match.params.id])
        .then(res => setCampaignDetails(res.data))
    }, []);

    const managersSave = (managers, campaignId) => {
        props.actions.brandCampaignManagerSave(managers, campaignId)
        .then(res => {
            notification.send({device: props.rdx.appReducer.deviceType, message: 'Updated!', type: 'success'});
        })        
    }

    return (
        <BaseLayout leftCards={[
            <CurrentCampaignSidebar campaignId={props.match.params.id} currentTitle='Campaign Manager'/>
            ]}>
            <div className="campaign-manager">
                <h1>Campaign Manager - {campaignDetails ? campaignDetails.campaignName : ''}</h1>
                <CampaignManagerComponent campaignId={props.match.params.id}
                    managersFetch={props.actions.brandCampaignManager}
                    managersSave={managersSave} />
            </div>
        </BaseLayout>
    );
}

//map state
const mapStateToProps = (state, ownProps) => ({rdx: state});

//map dispatch
const mapDispatchToProps = (dispatch, ownProps) => ({
    actions: bindActionCreators({
        brandCampaignManager,
        brandCampaignManagerSave,
        genericAction
    }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CampaignManager);